import { render } from "./Bandeaux.vue?vue&type=template&id=74b65e54"
import script from "./Bandeaux.vue?vue&type=script&lang=js"
export * from "./Bandeaux.vue?vue&type=script&lang=js"
script.render = render

export default script